<template>
  <section class="s-time" aria-labelledby="insurance-timeline-title">
    <h2 id="insurance-timeline-title" class="wd-title">
      <span class="s-time__base">¿Qué sucede después de</span> <span class="hl">enviar tu solicitud?</span>
    </h2>

    <ol class="s-time__steps">
      <li v-for="(step, index) in steps" :key="step.title" class="s-time__step">
        <span class="s-time__number">{{ index + 1 }}</span>
        <div class="s-time__body">
          <p class="s-time__title">{{ step.title }}</p>
          <p class="wd-body">{{ step.text }}</p>
        </div>
      </li>
    </ol>
  </section>
</template>

<script setup lang="ts">
const steps = [
  { title: 'Reporte recibido', text: 'Confirmaremos que tu solicitud fue recibida.' },
  { title: 'Revisión documental', text: 'Validaremos que tu expediente esté completo.' },
  { title: 'Evaluación de la aseguradora', text: 'La aseguradora analizará la reclamación y las condiciones de la cobertura.' },
  { title: 'Resolución', text: 'Te informaremos el resultado y los siguientes pasos.' }
]
</script>

<style scoped>
.s-time {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-5);
  padding: var(--ds-space-5) var(--ds-space-6);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 16px;
}
.s-time__base { color: var(--ds-purple-900); }

.s-time__steps { display: flex; flex-direction: column; gap: var(--ds-space-5); margin: 0; padding: 0; list-style: none; }
.s-time__step { display: flex; align-items: center; gap: var(--ds-space-4); }
.s-time__number {
  display: flex;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 40px;
  background: var(--ds-purple-900);
  color: var(--ds-tertiary);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.s-time__body { display: flex; flex: 1 1 0; flex-direction: column; gap: var(--ds-space-3); min-width: 0; }
.s-time__title { margin: 0; color: var(--ds-text-body); font-size: 16px; font-weight: 600; line-height: 24px; }

@media (max-width: 1024px) {
  .s-time { padding: var(--ds-space-5); }
}

@media (max-width: 599px) {
  .s-time { padding: var(--ds-space-5) var(--ds-space-4); }
}
</style>
